/** Canonical API/DB sample_type values → i18n slug under annotator.annotationPage.sampleTypes */
export const SAMPLE_TYPE_SLUG = {
  Letter: "letter",
  Word: "word",
  "Non-word": "nonWord",
  Sentence: "sentence",
  Passage: "passage",
  Paragraph: "paragraph",
  NCERT: "ncert",
  ShortStory: "shortStory",
  LongStory: "longStory",
  LongStoryQuestion: "longStoryQuestion",
  Unknown: "unknown",
};

const NORMALIZED_SLUG_LOOKUP = Object.fromEntries(
  Object.entries(SAMPLE_TYPE_SLUG).map(([canonical, slug]) => [
    canonical.trim().toLowerCase(),
    slug,
  ])
);

/**
 * Resolves an i18n slug for a sample_type label (exact or case-insensitive).
 * @param {string} label - Raw sample_type from API/DB
 * @returns {string|undefined}
 */
export function resolveSampleTypeSlug(label) {
  if (label == null || typeof label !== "string") return undefined;
  const trimmed = label.trim();
  if (!trimmed) return undefined;
  if (SAMPLE_TYPE_SLUG[trimmed]) return SAMPLE_TYPE_SLUG[trimmed];
  return NORMALIZED_SLUG_LOOKUP[trimmed.toLowerCase()];
}

/**
 * Localized display label for a sample_type tab. API payloads must keep the canonical English value.
 * @param {string} label - Raw sample_type from API/DB
 * @param {(key: string, fallback?: string) => string} t - translate function
 * @returns {string}
 */
export function translateSampleType(label, t) {
  if (label == null) return label;
  const displayFallback = typeof label === "string" ? label.trim() : String(label);
  const slug = resolveSampleTypeSlug(label);
  if (slug) {
    return t(`annotator.annotationPage.sampleTypes.${slug}`, displayFallback);
  }
  return displayFallback;
}
